import React from "react";
import { Navigate, Outlet } from "react-router-dom";

import { routes } from "./routes";
import { Role, useAuth } from "../components/auth/AuthenticationContext";

const homeOf: Record<Role, string> = {
  admin: routes.admin,
  praxis: routes.dashboard,
};

/**
 * Only renders the routes for the given role, other accounts are sent to their own home
 */
export const RoleRoute: React.FC<{ role: Role }> = ({ role }) => {
  const { account } = useAuth();

  if (!account) {
    return <Navigate to={routes.login} />;
  }
  if (account.role !== role) {
    return <Navigate to={homeOf[account.role]} replace />;
  }

  return <Outlet />;
};
